import { TAxiosError } from '@mgm/common/types';
import { useRequest } from '@mgm/common/lib';
import { CONTROLLERS } from '../utils/enums';

import { IInviteRegisterReq, TLoginRequest, TResetPass } from '../types/requests';
import { BASE_URL } from '../../config';
import { getIdToken } from '../utils/helpers';

export function LoginController() {
  const {
    axiosRequest,
    initRequestOptions,
  } = useRequest(BASE_URL);

  const controllerName = CONTROLLERS.LOGIN;

  const login = <T>(data: TLoginRequest): Promise<T | { success: boolean; error: TAxiosError }> => {
    const requestOptions = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/authenticate`, requestOptions);
  };

  const forgotPass = <T>(data: { email: string }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const requestOptions = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/reset`, requestOptions);
  };

  const resetPass = <T>(data: TResetPass): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/set_password`, options);
  };

  const register = <T>(data: IInviteRegisterReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/register`, options);
  };

  return {
    register,
    login,
    forgotPass,
    resetPass,
  };
}
